import React, { useCallback } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { useDebouncedCallback } from 'use-debounce'

import TagSelect from './TagSelect'
import {
  clearCaseworkTags,
  loadCaseworkTags,
  paginateCaseworkTags,
} from '../../../redux/features/caseworkSlice'
import { addLeadingZeroToDistrict } from '../../../utils'

const CaseworkTagSelect = ({ district, ...props }) => {
  const dispatch = useDispatch()
  const user = useSelector(state => state.auth.user)
  const isLoading = useSelector(state => state.casework.tags_loading)
  const filters = useSelector(state => state.casework.filters) || []
  const selectedDistrictFilter = filters.district__in

  const districtValue = user.is_admin
    ? district ?? undefined
    : addLeadingZeroToDistrict(user.district)

  const filterParams = {
    district__in: districtValue ? [districtValue] : selectedDistrictFilter,
    label: '',
  }

  const loadOptions = searchTerm => {
    dispatch(clearCaseworkTags())
    dispatch(loadCaseworkTags({ ...filterParams, label: searchTerm }))
  }

  const debouncedHandleChange = useDebouncedCallback(e => {
    loadOptions(e.target.value)
  }, 500)

  const loadMoreTags = useCallback(() => {
    dispatch(paginateCaseworkTags())
  }, [])

  const tagOptions = useSelector(state => state.casework.tag_options) || []

  return (
    <TagSelect
      district={district}
      onSearch={debouncedHandleChange}
      tagOptions={tagOptions}
      loadOptions={loadOptions}
      loadMoreOptions={loadMoreTags}
      isLoading={isLoading}
      {...props}
    />
  )
}

export default CaseworkTagSelect
